import { Document, Page, pdfjs } from "react-pdf";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = () => {
  const { key } = useParams();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [width, setWidth] = useState(800);

  useEffect(() => {
    const handleResize = () => {
      const newWidth =
        window.innerWidth > 1024
          ? 800
          : window.innerWidth > 768
          ? 600
          : window.innerWidth > 480
          ? 400
          : 300;
      setWidth(newWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLoadSuccess = ({ numPages }) => setNumPages(numPages);
  const goToPrevPage = () => pageNumber > 1 && setPageNumber(pageNumber - 1);
  const goToNextPage = () =>
    pageNumber < numPages && setPageNumber(pageNumber + 1);
  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 2.0));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));
  const resetZoom = () => setScale(1.0);

  return (
    <div
      style={{
        backgroundColor: "#f3f4f6",
        minHeight: "100vh",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1024px",
          marginBottom: "16px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          backgroundColor: "#fff",
          padding: "12px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            onClick={goToPrevPage}
            disabled={pageNumber <= 1}
            style={{
              padding: "6px 12px",
              backgroundColor: pageNumber <= 1 ? "#cbd5e1" : "#3b82f6",
              color: "#fff",
              borderRadius: "4px",
              cursor: pageNumber <= 1 ? "not-allowed" : "pointer",
              transition: "background-color 0.3s",
            }}
          >
            ←
          </button>
          <span style={{ color: "#374151", fontSize: "1rem" }}>
            Page {pageNumber} of {numPages || "--"}
          </span>
          <button
            onClick={goToNextPage}
            disabled={pageNumber >= (numPages || 0)}
            style={{
              padding: "6px 12px",
              backgroundColor:
                pageNumber >= (numPages || 0) ? "#cbd5e1" : "#3b82f6",
              color: "#fff",
              borderRadius: "4px",
              cursor: pageNumber >= (numPages || 0) ? "not-allowed" : "pointer",
              transition: "background-color 0.3s",
            }}
          >
            →
          </button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            onClick={zoomOut}
            disabled={scale <= 0.5}
            style={{
              padding: "6px 12px",
              backgroundColor: scale <= 0.5 ? "#f1f5f9" : "#e5e7eb",
              color: "#1f2937",
              borderRadius: "4px",
              cursor: scale <= 0.5 ? "not-allowed" : "pointer",
            }}
          >
            -
          </button>
          <span style={{ color: "#374151", fontSize: "1rem" }}>
            {Math.round(scale * 100)}%
          </span>
          <button
            onClick={zoomIn}
            disabled={scale >= 2.0}
            style={{
              padding: "6px 12px",
              backgroundColor: scale >= 2.0 ? "#f1f5f9" : "#e5e7eb",
              color: "#1f2937",
              borderRadius: "4px",
              cursor: scale >= 2.0 ? "not-allowed" : "pointer",
            }}
          >
            +
          </button>
          <button
            onClick={resetZoom}
            style={{
              padding: "6px 12px",
              backgroundColor: "#e5e7eb",
              color: "#1f2937",
              borderRadius: "4px",
              marginLeft: "8px",
              cursor: "pointer",
            }}
          >
            Reset
          </button>
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "8px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Document
            file={`${
              process.env.REACT_APP_BACKEND_BASEURL
            }/api/applications/resume/view/${encodeURIComponent(key)}`}
            onLoadSuccess={handleLoadSuccess}
            loading={
              <div
                style={{
                  height: "256px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6b7280",
                }}
              >
                Loading PDF...
              </div>
            }
            error={
              <div
                style={{
                  height: "256px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ef4444",
                }}
              >
                Failed to load PDF. Please try again later.
              </div>
            }
          >
            <Page
              pageNumber={pageNumber}
              width={width * scale}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              loading={
                <div
                  style={{
                    height: "256px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6b7280",
                  }}
                >
                  Loading page...
                </div>
              }
            />
          </Document>
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "16px",
          left: 0,
          right: 0,
          display: window.innerWidth <= 768 ? "flex" : "none",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            backgroundColor: "#fff",
            padding: "12px",
            borderRadius: "9999px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          }}
        >
          <button
            onClick={goToPrevPage}
            disabled={pageNumber <= 1}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: pageNumber <= 1 ? "#cbd5e1" : "#3b82f6",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: pageNumber <= 1 ? "not-allowed" : "pointer",
            }}
          >
            ←
          </button>
          <button
            onClick={goToNextPage}
            disabled={pageNumber >= (numPages || 0)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor:
                pageNumber >= (numPages || 0) ? "#cbd5e1" : "#3b82f6",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: pageNumber >= (numPages || 0) ? "not-allowed" : "pointer",
            }}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
//hello
